require('./bootstrap');
require('./components/slider');
require('./components/mask')